import React from 'react';

import './styles/Career.css';

import career_image from '../assets/career.webp';

function Career() {
	return (
		<section className='career'>
			<div className='career-image'>
				<img src={career_image} alt='Me' />
			</div>
			<div className='career-content'>
				<div className='career-section'>
					<div className='career-line'></div>
					<div className='career-title'>
						<span>Work</span>
					</div>
					<div className='career-item'>
						<div className='career-right'>
							<div>
								<div className='career-item-title'>Gapstars - Software Developer</div>
								<div className='career-item-description'>
									Dedicated to ESTG, Europe's largest distributor of sustainable energy products. I focus on building and maintaining scalable backend services and cloud infrastructure to support business growth and operational reliability.
								</div>
								<div className='career-positions'>
									<div className='career-positions-left'>
										<div className='career-positions-circle'></div>
									</div>
									<div className='career-positions-right'>
										<div className='career-item-subtitle'>
											Backend Developer <span> • Nov 2024 - Present</span>
										</div>
									</div>
								</div>
							</div>
							<br></br>
							<div>
								<div className='career-item-title'>Magroove - Software Developer</div>
								<div className='career-item-description'>
									Developed and maintained web and mobile applications, integrating them with databases and ensuring smooth user experiences. Led end-to-end development, from implementation to deployment, and helped improve processes through code reviews and team collaboration.
								</div>
								<div className='career-positions'>
									<div className='career-positions-left'>
										<div className='career-positions-circle'></div>
										<div className='career-positions-line'></div>
										<div className='career-positions-circle'></div>
										<div className='career-positions-line'></div>
										<div className='career-positions-circle'></div>
									</div>
									<div className='career-positions-right'>
										<div className='career-item-subtitle'>
											Full Stack Developer <span> • Jul 2022 - Oct 2024</span>
										</div>
										<div className='career-item-subtitle'>
											Full Stack Developer Jr <span> • Sep 2021 - Jun 2022</span>
										</div>
										<div className='career-item-subtitle'>
											Developer Intern <span> • Jul 2020 - Aug 2021</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className='career-section'>
					<div className='career-line'></div>
					<div className='career-title'>
						<span>Education</span>
					</div>
					<div className='career-item'>
						<div className='career-right'>
							<div className='career-item-title'>Instituto Superior de Engenharia de Lisboa - Politécnico de Lisboa</div>
							<div className='career-item-description'></div>
							<div className='career-positions'>
								<div className='career-positions-left'>
									<div className='career-positions-circle'></div>
								</div>
								<div className='career-positions-right'>
									<div className='career-item-subtitle'>
										IT & Computer Engineering <span> • Sep 2023 - Present</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className='career-item'>
						<div className='career-right'>
							<div className='career-item-title'>Instituto de Matemática e Estatística - Universidade de São Paulo</div>
							<div className='career-item-description'></div>
							<div className='career-positions'>
								<div className='career-positions-left'>
									<div className='career-positions-circle'></div>
									<div className='career-positions-line'></div>
									<div className='career-positions-circle'></div>
								</div>
								<div className='career-positions-right'>
									<div className='career-item-subtitle'>
										Applied Mathematics <span> • Jan 2021 - Jul 2023</span>
									</div>
									<div className='career-item-subtitle'>
										Statistics <span> • Mar 2017 - Dec 2020</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default Career;
